export const mapLink = (link: Umbraco.Link): Content.Link => {
	if (!link) {
		return null;
	}

	return {
		linkType: link.linkType || null,
		target: link.target || null,
		name: link.title || null,
		url: link.url ? link.url : link.route?.path || null,
	};
};

export const mapFirstLink = (links: Umbraco.Link[]): Content.Link => {
	if (!links) {
		return null;
	}

	return mapLink(links.find((x) => x !== undefined));
};

export const mapLinks = (links: Umbraco.Link[]): Content.Link[] => {
	if (!links) {
		return [];
	}
	return links.map((link) => mapLink(link));
};
